define( function() {

	// All support tests are defined in their respective modules.
	return {};
} );



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/jquery/src/var/support.js
 ** module id = 824
 ** module chunks = 2
 **/